import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { List } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';

const StoreFacilities = (_param)=>{
    var { className , labels , facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "facilities"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-facilities-stores-v2', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React.createElement(List, {
        items: facilities,
        icon: "checkmark"
    }));
};

export { StoreFacilities as default };
//# sourceMappingURL=StoreFacilities.js.map
